var React = require('react');

function CircleInline (props) {
    return React.createElement("svg",props,React.createElement("ellipse",{"cx":"192.5","cy":"192","rx":"192.5","ry":"192","fill":"#DFE3FF"}));
}

CircleInline.defaultProps = {"width":"385","height":"384","viewBox":"0 0 385 384","fill":"none"};

module.exports = CircleInline;

CircleInline.default = CircleInline;
